import { useSearchParams } from 'react-router-dom'

export const useGetParamQuery = (param: string) => {
  const [searchParams] = useSearchParams()
  return searchParams.get(param)
}
